module.exports = __webpack_public_path__ + "static/media/clown-fish.06c13099.svg";